import { createElementBlock as o, openBlock as n, createElementVNode as t } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14"
};
function l(s, e) {
  return n(), o("svg", r, [...e[0] || (e[0] = [
    t("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M10.57 3.024a.31.31 0 0 1 .406.406l-3.059 7.378a.311.311 0 0 1-.592-.058l-.68-3.395-3.395-.68a.311.311 0 0 1-.058-.592z"
    }, null, -1)
  ])]);
}
const c = { render: l };
export {
  c as default,
  l as render
};
